export const NBSP = '\u00A0';
export const NBHY = '\u2011';
export const LF = '\u000A';
